import React from 'react';
import { Poppins, Spacer } from 'src/common';
import _ from 'lodash';
import { useColumns } from './useColumns';
import GenericTable from 'src/components/GenericTable';
import { TableIds } from 'src/api/types/misc';
import { ComparisonAssessmentQuery } from 'src/graphql/_generated';

type AssessmentData = NonNullable<ComparisonAssessmentQuery['assessmentA']>;

interface AssessmentViewProps {
  data: AssessmentData;
  genPath: (a: AssessmentData['scenarios'][0]) => string | undefined;
}

export const AssessmentView: React.FC<AssessmentViewProps> = ({ data, genPath }) => {
  const showAllProjected = !!data?.scenarios
    ?.flatMap((scenario) =>
      scenario.riskManagementPlans
        ?.filter((plan) => plan.control && plan.control.status !== 'Abandoned' && plan.control.status !== 'Retired')
        ?.flatMap((plan) => plan.modifiers),
    )
    ?.filter((modifier) => modifier.type !== 'NOTE_TYPE')?.length;

  const { columns, GTColumnSelectAnchorExported } = useColumns({
    data: data?.scenarios || [],
    genPath,
    showAllProjected,
  });

  return (
    <>
      <Poppins weight={600} px={22} color="prussianBlue">
        {data.name}
      </Poppins>
      <Spacer $px={15} />
      <div>
        <Poppins weight={600} px={22} color="prussianBlue">
          {data.scenarios.length}
        </Poppins>
        <Poppins px={18} className="scenario-label" color="cflowerBlue" css="margin-left: 5px;">
          scenario{data.scenarios.length > 1 ? 's' : ''}
        </Poppins>
      </div>
      <Spacer $px={15} />
      <GenericTable
        tableId={TableIds.compareAssessments}
        data={data.scenarios}
        columns={columns}
        GTColumnSelectAnchorExported={GTColumnSelectAnchorExported}
      />
    </>
  );
};
